// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';

/**
 * A LABEL AND ITS VALUE, read as one pair at any width (index.css .kv-row). In a row wide enough, the label takes a
 * column — a third of the row, at least 6.5rem — and the value starts right after it, left-aligned, so values line up
 * down a card and a wide card does not put the width of the page between a label and what it labels. In a row too
 * narrow for two columns (a 150px rail) the label sits above its value instead of either being cut. The row decides
 * from its own width. `KV_ROW` is that row for a page's own label/value lines: first child the label, second the value.
 */
export const KV_ROW = 'kv-row';

export const KV = ({ label, value, mono = false }) => (
  <div className={`${KV_ROW} py-1.5`}>
    <span className="text-[12px] text-[#6B7280]">{label}</span>
    <span className={`text-[12.5px] text-[#1F2937] [overflow-wrap:anywhere] ${mono ? 'font-mono text-[12px]' : ''}`}>{value}</span>
  </div>
);

